import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from "../../../utils/customModal";
import { withTranslation } from "react-i18next";
import TokenComponent from "../../../shared/token";
//import { MOD_PROVID } from "../../../../permissions";
import * as instanceActions from "../../../../Redux/api";
import TableAdmissions from "../../../shared/admissions/table";
import { getModules } from "../../../../Redux/reducer/clients";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import ProviderTemporal from "../../../shared/provider/providerTemporal";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import { getAuthenticatedClientModules } from "../../../../Redux/actions/clientActions";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
  //getNumberApprovals,
} from "../../../utils/functions";
import {
  getPendingProviders,
  getTotalPendingProviders,
} from "../../../../Redux/reducer/providers";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import {LABELS_ACCOUNT_TYPE} from '../../../shared/AccountTypeSelect';

const Admissions = (props) => {
  const { t } = props;
  let signal;

  const [state, setState] = useState({
    filter: [],
    page: 0,
    sizePerPage: 10,
    contentReady: false,
    modal: { show: false, content: null, onClose: undefined },
    token: { show: false, code: null },
    data: { approve: undefined, elements: undefined },
    menus: [],
    list: true,
    component: false,
    companyId: 0,
    providerId: 0,
  });

  useEffect(() => {
    console.log(props);
    const controller = new AbortController();
    signal = controller.signal;
    var customFilters = getFilters();

    props.setFilters({ filterItems: customFilters, filterSearch: searchFnc });

    if (props.clientModules.length <= 0) {
      props.getModules();
    }

    getPendingData();

    return () => {
      props.actions.clearPendingProviders();
      controller.abort();
    };
  }, []);

  const getFilters = () => {
    return [
      {
        name: `${props.t("general.filters.name")}`,
        property: "provider.institution.name",
        operator: "eq",
      },
      {
        name: `${props.t("general.filters.identification")}`,
        property: "provider.institution.businessId",
        operator: "eq",
      },
    ];
  };

  const getPendingData = (filter = []) => {
    const { getProvidersAdditionsAccounts } = props.actions;
    const { page, sizePerPage } = state;

    return getProvidersAdditionsAccounts(
      page,
      sizePerPage,
      filter,
      signal
    ).then(() => {
      setState({ ...state, contentReady: true });
    });
  };

  const searchFnc = (property, value) => {
    var currentFilters = [];
    if (value !== "") {
      var operator = "";
      var customFilters = getFilters();

      customFilters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });

      currentFilters = [
        { property: property, operator: operator, value: value },
      ];
    }
    //setState({ ...state, page: 0, filter: currentFilters });
    setState((prevState) => {
      return { ...prevState, page: 0, filter: currentFilters };
    });
    getPendingData(currentFilters);
  };

  const getData = () => {
    const { pending, t } = props;
    var resultData = [];

    if (pending.length > 0) {
      pending.map((item) => {
        resultData.push({
          id: item.id,
          name: item.companyName,
          requestType: t(`general.relationTypes.${item.requestType}`),
          //requestType: item?.requestType,
          cedJuridica: item.businessId,
          currency: item?.currency || item?.providerAccountCurrency,
          payMethod: LABELS_ACCOUNT_TYPE[item.accountType] || "-",
          bank:
            item.bicDestinationBank !== undefined &&
            item.bicDestinationBank != null
              ? item.bicDestinationBank
              : "-",
          account:
            item.accountNumber !== undefined && item.accountNumber != null
              ? item.accountNumber
              : "-",
          item,
        });
      });
    }

    return resultData;
  };

  const closeInfo = () => {
    setState({
      ...state,
      list: true,
      component: false,
    });
  };

  const handlerTableChange = ({ page, sizePerPage }) => {
    const { getProvidersAdditionsAccounts } = props.actions;

    return getProvidersAdditionsAccounts(
      page,
      sizePerPage,
      state.filter,
      signal
    ).then(() => {
      setState({ ...state, page, sizePerPage });
    });
  };

  const closeModal = () => {
    setState({
      ...state,
      modal: { show: false, content: null, onClose: undefined },
    });
  };

  const validate = ({ validToken = null }) => {
    const { token } = state;

    if (validToken === null) {
      token.show = true;
      setState({ ...state, token });
    } else {
      token.show = false;
      token.code = validToken;
      setState({ ...state, token }, () => commitActions());
    }
  };

  const handleMenu = (id, open) => {
    const { menus } = state;
    menus[`menu-${id}`] = open;
    setState({ ...state, menus });
  };

  const getHeaders = () => {
    const { menus } = state;
    const { t } = props;
    return [
      { selector: "name", name: `${t("admissions.headers.suppliers.name")}` },
      {
        selector: "requestType",
        name: `${t("admissions.headers.suppliers.requestType")}`,
      },
      {
        selector: "cedJuridica",
        name: `${t("admissions.headers.suppliers.id")}`,
      },
      {
        selector: "payMethod",
        name: `${t("admissions.headers.suppliers.payMethod")}`,
      },
      { selector: "bank", name: `${t("admissions.headers.suppliers.bank")}` },
      {
        selector: "account",
        name: `${t("admissions.headers.suppliers.account")}`,
      },
      {
        selector: "accion",
        name: `${t("providers.table.headers.action")}`,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.id, open)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`related-${row.item.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => handleMenu(row.item.id, false)}
              link={{
                href: `/admissions/detail/${row.item.providerId}/${row.item.requestType}/${row.currency}`,
              }}
            >
              {t(`general.labels.viewProfile`)}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  const commitActions = (approve, elements) => {
    const { modal, token, data } = state;

    const {
      instance: { instanceAction },
      t,
    } = props;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    // const approvals = 0; //getNumberApprovals(props.clientModules, MOD_PROVID);

    // if (approvals >= 1) {
    //   if (token.code === null) {
    //     token.show = true;
    //     setState({ ...state, token, data });
    //     return false;
    //   }
    // }

    modal.content = loadingHtml();
    modal.show = true;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    setState({ ...state, modal, data });
    var updateStates = [];

    var apiHeader =
      token.code !== null ? { "x-security-code": token.code } : {};
    Object.keys(data.elements).map((key) => {
      var idProvider = key.split("-")[1];
      updateStates.push({
        id: idProvider,
        approve: data.approve,
      });

      return true;
    });
    return instanceAction(
      "/providers/additions-modifications-accouts-csa/approve-or-rejected",
      "post",
      updateStates,
      apiHeader
    )
      .then((response) => {
        modal.show = false;
        modal.content = null;
        setState({ ...state, modal });
        let detail = "";
        if (response.data.data.totalLines == response.data.data.totalLinesOk) {
          detail = <p>{t("general.successMessage")}</p>;
        } else {
          detail = (
            <>
              <p>Se presentaron los siguientes errores:</p>
              <ul>
                {response.data.data.details.map(({ message }, key) => (
                  <li key={`res-${key}`}>{message}</li>
                ))}
              </ul>
            </>
          );
        }

        let button = { formBtn: { text: "Continuar", action: closeModal } };
        modal.content = sucessInfoModal(
          "Adiciones/Modificaciones",
          detail,
          button
        );
        modal.show = true;
        setState({ ...state, modal });
        getPendingData();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description,
            {
              cancelBtn: {
                text: `${t("general.buttons.close")}`,
                action: () => closeModal(),
              },
            }
          );
        }
        modal.onClose = () => closeModal();

        setState({
          ...state,
          contentReady: false,
          modal,
          token: { show: false, valid: false },
        });
        return getPendingData();
      });
  };

  const goBack = () => {
    setState({ ...state, token: { show: false, code: null } });
  };

  const {
    contentReady,
    sizePerPage,
    page,
    component,
    companyId,
    providerId,
    list,
    token,
  } = state;

  return (
    <>
      {contentReady ? (
        props.pending.length > 0 ? (
          list && (
            <>
              <TableAdmissions
                headers={getHeaders()}
                data={getData()}
                page={page}
                totalSize={props.total}
                sizePerPage={sizePerPage}
                addmissionType={`providers`}
                onTableChange={handlerTableChange}
                submitAdmissions={commitActions}
              />
              {token.show && <TokenComponent send={validate} goBack={goBack} />}
            </>
          )
        ) : (
          <div id="blankAprrovals">
            <img src={noAproval} className="clientImage" />
            <p>{t("admissions.noAdmissions")}</p>
            <div className="line red"></div>
          </div>
        )
      ) : (
        <div className="loader innner"></div>
      )}
      {component && (
        <ProviderTemporal
          closeInfo={closeInfo}
          companyId={companyId}
          providerId={providerId}
        />
      )}
      <Modal show={state.modal.show} handleClose={state.modal.onClose}>
        {state.modal.content}
      </Modal>
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    pending: getPendingProviders(state),
    total: getTotalPendingProviders(state),
    clientModules: getModules(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
    getModules: () => dispatch(getAuthenticatedClientModules()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(Admissions));
